import { ErrorHandler, Injector, Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  template: ''
})
export class ErrorComponent extends ErrorHandler {

  constructor(private injector: Injector) {
    super(null);
  }

  handleError(error: any): void {
    /* tslint:disable-next-line:no-console */
    console.error('exception caught: ', error);

    this.injector.get(Router).navigate(['/']);
  }
}



// WEBPACK FOOTER //
// C:/Program Files (x86)/Jenkins/workspace/tss-keno-web/vit-keno/src/app/error/error.component.ts